export enum LogoType {
LOGO_MAIN = "LOGO_MAIN",
  LOGO_LOGIN = "LOGO_LOGIN",
  LOGO_EMAIL = "LOGO_EMAIL",
  NO_LOGO = "NO_LOGO"
}

export enum RequestedFormat{
  E = "E",
  P = "P"}

export class PRFormCustomDetails{
  id:number;
  formEnabled: boolean;
  logoType: LogoType;
  selectedLogoPath: string;
  formColor: string;
  formTitle: string;
  formSubtitle: string;
  formHeaderText: string;
  formFooterText: string;
  displayElectronic:boolean;
  displayPhysical:boolean;
  defaultRequestedFormat: RequestedFormat;

  constructor(data:any) {
    this.id = data.id;
    this.formEnabled = data.formEnabled;
    this.logoType = data.logoType;
    this.selectedLogoPath = data.selectedLogoPath;
    this.formColor = data.formColor;
    this.formTitle = data.formTitle ? data.formTitle : 'ng.rialto.pr_form_def_title';
    this.formSubtitle = data?.formSubtitle;
    this.formHeaderText = data?.formHeaderText;
    this.formFooterText = data?.formFooterText;
    this.displayElectronic = data.displayElectronic;
    this.displayPhysical = data.displayPhysical;
    this.defaultRequestedFormat = data.defaultRequestedFormat ? data.defaultRequestedFormat : RequestedFormat.P;
  }
}
